module.exports = __webpack_public_path__ + "img/icon-slot-black.d37e18f5.svg";